import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';
import 'react-reflex/styles.css';
import { BsThreeDotsVertical, BsThreeDots } from 'react-icons/bs';

const ReflexFourHorizontalContainer = ({
  Left,
  LeftMiddle,
  RightMiddle,
  Right,
  ratio,
}) => {
  const size = {
    left: !!ratio ? ratio.left : 1,
    leftMiddle: !!ratio ? ratio.leftMiddle : 1,
    rightMiddle: !!ratio ? ratio.rightMiddle : 1,
    right: !!ratio ? ratio.right : 1,
  };

  return (
    <ReflexContainer orientation="vertical">
      <ReflexElement style={{ overflow: 'hidden' }} className="pane-content" flex={size.left}>
        {Left}
      </ReflexElement>
      <ReflexSplitter
        propagate={true}
        style={{
          position: 'relative',
          background: '#edecec',
          width: '3.2px',
          border: 0,
        }}
      >
        <BsThreeDotsVertical
          style={{
            position: 'absolute',
            top: '50%',
            left: '-6.1px',
            color: '#a09f9f',
          }}
        />
      </ReflexSplitter>
      <ReflexElement style={{ overflow: 'hidden' }} className="pane-content" flex={size.leftMiddle}>
        {LeftMiddle}
      </ReflexElement>
      <ReflexSplitter
        propagate={true}
        style={{
          position: 'relative',
          background: '#edecec',
          width: '3.2px',
          border: 0,
        }}
      >
        <BsThreeDotsVertical
          style={{
            position: 'absolute',
            top: '50%',
            left: '-6.1px',
            color: '#a09f9f',
          }}
        />
      </ReflexSplitter>
      <ReflexElement style={{ overflow: 'hidden' }} className="pane-content" flex={size.rightMiddle}>
        {RightMiddle}
      </ReflexElement>
      <ReflexSplitter
        propagate={true}
        style={{
          position: 'relative',
          background: '#edecec',
          width: '3.2px',
          border: 0,
        }}
      >
        <BsThreeDotsVertical
          style={{
            position: 'absolute',
            top: '50%',
            left: '-6.1px',
            color: '#a09f9f',
          }}
        />
      </ReflexSplitter>
      <ReflexElement style={{ overflow: 'hidden' }} className="pane-content" flex={size.right}>
        {Right}
      </ReflexElement>
    </ReflexContainer>
  );
};

export default ReflexFourHorizontalContainer;
